<template>
<div>

    <div class="container-fluid">
        <div class="row">

            <div class="col-lg-12">
                <div class="card box-margin">
                    <div class="card-header">
                        <i class="fas fa-id-card"></i><span> Documentos</span>
                        <div class="btn-group" role="group">
                            <template v-if="AsignarRolPermisosByUsuario.includes('documento.crear')">
                                <button type="button" class="btn btn-success" @click="abrirModal"><i class="fas fa-plus-circle"></i>Agregar</button>
                            </template>

                        </div>

                    </div>
                    <div class="card-body">

                        <div class="shortcode-html">
                            <!-- Table Bordered -->

                            <div class="form-group row">

                                <div class="form-inline col-md-6 col-sm-12">
                                    <div class="form-group col">
                                        <label >Mostrar</label>
                                            <select v-model="pag_mostrar" class="form-control" v-on:change="getListDocumento(1,pag_mostrar)">
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        <label >registros por página</label>
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-12">
                                    <div>
                                        <el-input @keyup.enter.native="getListDocumento(1,pag_mostrar)" placeholder="Texto a buscar" v-model="cBusqueda" class="input-with-select" clearable>
                                            <el-select v-model="cCriterio" slot="prepend" placeholder="Select">
                                            <el-option value="tipo_doc" label="Documento"></el-option>

                                            </el-select> <i class="fas fa-search"></i>
                                            <el-button class="button-library-group" slot="append" icon="fas fa-search" @click.prevent="getListDocumento(1,pag_mostrar)"></el-button>
                                        </el-input>
                                    </div>
                                </div>

                            </div>

                            <div  class="table-responsive">

                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th><b>Tipo Documento</b></th>
                                            <th><b>Acciones</b></th>
                                        </tr>
                                    </thead>

                                    <tbody  v-if="listDocumento.length">
                                        <tr v-for="(c, index) in listDocumento" :key="index">

                                            <td v-text="c.tipo_doc"></td>

                                            <td>
                                                <div class="btn-group mb-2 mr-2">
                                                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-filter"></i> Acción</button>
                                                    <div class="dropdown-menu">
                                                        <template v-if="AsignarRolPermisosByUsuario.includes('documento.editar')">
                                                            <button class="dropdown-item" @click="setObtenerDocumento(c)"><i class="fa fa-edit text-info" ></i> Editar</button>
                                                        </template>
                                                        <template v-if="AsignarRolPermisosByUsuario.includes('documento.eliminar')">
                                                            <button class="dropdown-item"  @click="setDeleteDocumento(c.id)"><i class="fa fa-trash text-danger" ></i> Eliminar</button>
                                                        </template>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                     <tbody v-else>
                                        <tr>
                                            <td colspan="4" align="center">
                                                <h5>No se encontraron resultados...</h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                                <nav style="float: left;">  Mostrando la página <span v-text="pagination.current_page"></span> de <span v-text="pagination.last_page"></span></nav>
                                 <nav style="float: right;">


                                    <ul class="pagination singel-page flex-wrap" >
                                        <li class="page-item" v-if="pagination.current_page > 1">
                                            <a class="page-link" @click.prevent="cambiarPagina(pagination.current_page - 1)" href="#">Anterior</a>
                                        </li>
                                        <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(page)" v-text="page"></a>
                                        </li>
                                        <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(pagination.current_page + 1)">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>


                            <!-- End Table Bordered -->
                        </div>

                    </div>
                </div>
            </div>


        </div>

        <!--   Inicio modal Usuario-------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modalShow }" :style=" modalShow ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-md modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal">Registrar Usuario</h5>
                        <button type="button" @click="abrirModal" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                       <form>
                           <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="LeadName">Nombre</label>
                                        <input type="text" class="form-control" id="name" v-model="vaCreDocumento.cDocumento" placeholder="Ingresar Nombre del Documento">
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>

                     <div class="modal-footer">
                            <button type="button" v-if="actu_reg==0" class="btn btn-sm btn-primary" @click="setRegistrarDocumento" v-text="nameButon">Guardar</button>
                            <button type="button" v-if="actu_reg==1" class="btn btn-sm btn-primary" @click="setActualizarDocumento" v-text="nameButon">Actualizar</button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrirModal">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal Usuario-------------------------------------------------------------->

    </div>

</div>
</template>

<script>

import {alertasM} from '../../../util.js';
export default {
    props: ['ruta'],
    data() {
        return {
            cCriterio: 'tipo_doc',
            cBusqueda: '',
            listDocumento: [],
            pagination : {
                    'total' : 0,
                    'current_page' : 0,
                    'per_page' : 0,
                    'last_page' : 0,
                    'from' : 0,
                    'to' : 0,
                },
            offset: 3,
            pag_mostrar: 5,//registros a mostrar por pagina tipo datable
            modalShow: false,

            mostrarModal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultarModal: {
                display: 'none'
            },
            vaCreDocumento:{
                eId: 0,
                cDocumento: '',

            },
            tituloModal: '',
            nameButon: '',
            actu_reg: 0, //0 registrar - 1 actualizar
            AsignarRolPermisosByUsuario: JSON.parse(localStorage.getItem('listRolPermisosByUsuario')),



        }
    },
    mixins: [alertasM],
    computed: {
            isActived: function() {
                return this.pagination.current_page;
            },
            //Calcula los elementos de la paginación
            pagesNumber: function() {
                if (!this.pagination.to) {
                    //si la pagina es diferente al ultimo elemento de la pagina actual, retornamos
                    return []; //Array vacio
                }

                var from = this.pagination.current_page - this.offset;
               // console.log("bengy: ", from);
                if (from < 1) {
                    //si la pagina actual es 0 entonces la igualamos  a uno
                    from = 1;
                }
                //la suma de la variable rom + el doble de la varialbe offset
                var to = from + this.offset * 2;
               // console.log("bengy2: ", from);
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }

                var pagesArray = [];
                while (from <= to) {
                    /*   pagesArray.push(from);//Ocurre desbordamiento, cuando son muchos registros
                                from++; */
                    //Solucion
                    if (
                        (from >= this.pagination.current_page - 1) &
                        (from <= this.pagination.current_page + 3)
                    )
                        pagesArray.push(from);
                    from++;
                }
                return pagesArray;
            },
        },
    methods: {


        getListDocumento(page,pag_mostrar){

          var url = '/documento';
          this.openCargando();//Activamos pantalla de carga de bloqueo
          axios.get(url,{
              params:{
                  'cCriterio': this.cCriterio,
                  'cBusqueda': this.cBusqueda,
                  'page' : page,
                  'pag_mostrar': pag_mostrar
              }
          })
          .then(res => {
                var respuesta = res.data;
                this.listDocumento = respuesta.documento.data;
                this.pagination = respuesta.pagination;
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
          })
          .catch(err => {
              if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
              this.openCargando(true);//Desactivamos ventana de carga de bloqueo
          })

        },

        cambiarPagina(page) {
                let me = this;
                //Actualiza la página actual
                me.pagination.current_page = page;
                //Envia la petición para visualizar la data de esa página
                me.getListDocumento(page,me.pag_mostrar);
        },

        abrirModal() {
            this.modalShow = !this.modalShow;

            if(this.modalShow==true){

                this.tituloModal = "Registrar Documento";
                this.actu_reg = 0;
                this.nameButon = "Guardar";

            }else{
               // this.aTipoDocumento = [];
                this.cleanVariables();
            }
        },

        cleanVariables(){
            this.vaCreDocumento.cDocumento = "";
            this.vaCreDocumento.eId = "";
        },

        setRegistrarDocumento(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/documento/registrar';


            axios.post(url, {
                'tipo_doc' : this.vaCreDocumento.cDocumento,
            }).then(res => {

                this.cleanVariables();//Limpiamos el form
                this.getListDocumento(1,this.pag_mostrar);
                this.modalShow=false;

                if(res.data.status){

                    this.notify(" Documento registrado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                }

            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                console.error(err);
            })
        },

        setActualizarDocumento(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/documento/actualizar';

            axios.put(url, {
                'id': this.vaCreDocumento.eId,
                'tipo_doc': this.vaCreDocumento.cDocumento,

            }).then(res => {


                this.cleanVariables();//Limpiamos el form
                //this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                this.getListDocumento(1,this.pag_mostrar);
                this.modalShow=false;
                if(res.data.status){

                    this.notify(" Documento actualizado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                }

            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                console.error(err);
            })
        },

        setObtenerDocumento(data){
            //console.warn(data);
            this.tituloModal = "Actualizar Documento";
            this.nameButon = "Actualizar"
            this.vaCreDocumento.eId = data.id;
            this.vaCreDocumento.cDocumento = data.tipo_doc;
            this.modalShow = true;
            this.actu_reg = 1;
        },

        //Eliminar Documento
        setDeleteDocumento(id){
            this.swalWithBootstrapButtons.fire({
                title: '¿Está seguro de eliminar el Documento?',
                //text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText:  'Si, eliminar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
                }).then((result) => {

                    if(result.value){
                        var url = '/documento/delete';
                        this.openCargando();
                        axios.post(url,{
                            'id': id,
                        })
                        .then(res => {
                            console.log(res);

                             this.openCargando(true);

                            if(res.data.status){
                                this.notify(" Documento Eliminado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                            }else{
                                this.notify(" El documento no se puede eliminar por que está en uso","","top","center","fas fa-exclamation-triangle","warning",' flipInX','flipOutX')
                            }
                            this.getListDocumento(1,this.pag_mostrar);
                        })
                        .catch(err => {
                             this.openCargando(true);
                            if (err.response.status == 401) {
                                    this.$router.push({name: 'login'})
                                    location.reload();
                                    localStorage.clear();
                                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                            }
                            console.error(err);
                        })
                }
            })
        },

    },
    mounted() {

            this.getListDocumento(1,this.pag_mostrar);


        },
}
</script>

<style>
</style>
